export default __webpack_public_path__ + "static/media/23-min.6bbeae0f.png";